import PropTypes from 'prop-types';
import React from 'react';

import LegacyDropdownMenu from 'ui-library/dropdowns/legacy/LegacyDropdownMenu';
import {ElementMouseEvent} from 'util/Types';

export default function StageFlowNodeDropdownMenu(props: StageFlowNodeDropdownMenuProps): JSX.Element {
  const {
    onClickSetParent,
    onRemoveNode,
    onRemoveNodeAndDownstreamNodes,
    onClickDuplicateTree,
    onClickExplodeTree,
    onClickSetExperimentalCondition,
    openSetExperimentalConditionDisabled,
  } = props;
  const menuSections = [
    [
      {
        name: 'Set experimental conditions',
        handleOnClick: onClickSetExperimentalCondition,
        disabled: openSetExperimentalConditionDisabled,
      },
      {
        name: 'Select input source',
        handleOnClick: onClickSetParent,
      },
    ],
    [
      {
        name: 'Duplicate branch',
        handleOnClick: onClickDuplicateTree,
      },
      {
        name: 'Split by conditions',
        handleOnClick: onClickExplodeTree,
      },
    ],
    [
      {
        name: 'Delete run',
        handleOnClick: onRemoveNode,
      },
      {
        name: 'Delete this and all downstream runs',
        handleOnClick: onRemoveNodeAndDownstreamNodes,
      },
    ],
  ];

  return <LegacyDropdownMenu items={menuSections} menuStyle={LegacyDropdownMenu.STYLES.COMPACT} />;
}

interface StageFlowNodeDropdownMenuProps {
  onClickSetParent: (e: ElementMouseEvent) => void;
  onRemoveNode: (e: ElementMouseEvent) => void;
  onClickDuplicateTree: (e: ElementMouseEvent) => void;
  onClickExplodeTree: (e: ElementMouseEvent) => void;
  onRemoveNodeAndDownstreamNodes: (e: ElementMouseEvent) => void;
  onClickSetExperimentalCondition: (e: ElementMouseEvent) => void;
  openSetExperimentalConditionDisabled: boolean;
}

StageFlowNodeDropdownMenu.propTypes = {
  onClickSetParent: PropTypes.func.isRequired,
  onRemoveNode: PropTypes.func.isRequired,
  onClickDuplicateTree: PropTypes.func.isRequired,
  onClickExplodeTree: PropTypes.func.isRequired,
  onRemoveNodeAndDownstreamNodes: PropTypes.func.isRequired,
  onClickSetExperimentalCondition: PropTypes.func.isRequired,
  openSetExperimentalConditionDisabled: PropTypes.bool.isRequired,
};
